import { regionValues as AU } from './AU';
import { regionValues as CA } from './CA';
import { regionValues as ES } from './ES';
import { regionValues as UK } from './UK';
import { regionValues as US } from './US';
import { regionValues as FR } from './FR';
import { regionValues as DE } from './DE';
import { regionValues as IT } from './IT';
import { regionValues as LU } from './LU';
import { regionValues as BE } from './BE';
import { regionValues as NL } from './NL';
import { regionValues as AT } from './AT';
import { regionValues as IE } from './IE';
import { regionValues as DK } from './DK';
import { regionValues as FI } from './FI';
import { regionValues as SE } from './SE';
import { regionValues as NO } from './NO';
import { regionValues as CH } from './CH';
import { regionValues as CL } from './CL';
import { regionValues as LT } from './LT';
import { regionValues as NZ } from './NZ';
import { regionValues as MY } from './MY';
import { regionValues as PT } from './PT';
import { regionValues as PL } from './PL';
import { regionValues as GR } from './GR';
import { regionValues as CZ } from './CZ';
import { regionValues as SG } from './SG';
import { regionValues as SN } from './SN';
import { regionValues as RO } from './RO';
import { regionValues as PR } from './PR';
export const regions = {
  AU,
  CA,
  ES,
  UK,
  US,
  FR,
  DE,
  IT,
  LU,
  LT,
  BE,
  NL,
  AT,
  IE,
  DK,
  FI,
  SE,
  NO,
  CH,
  CL,
  NZ,
  MY,
  PT,
  PL,
  GR,
  CZ,
  SG,
  SN,
  RO,
  PR,
};



// WEBPACK FOOTER //
// ./src/environment/region/regions.ts